import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createReturnReasonConfigBottom, createReturnReasonConfigTop } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/BRIDGE PIKETROJA - white.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/BRIDGE PIKETROJA - white.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/BRIDGE PIKETROJA - grey.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Grey",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/BRIDGE PIKETROJA - grey.jpeg",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Grey",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/BRIDGE PIKETROJA - red.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Red",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/BRIDGE PIKETROJA - red.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Red",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/STUART STRIPED BYXOR- black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/STUART STRIPED BYXOR- black.jpeg",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/STUART STRIPED BYXOR - white.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/STUART STRIPED BYXOR - white.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/STUART STRIPED BYXOR - white.jpeg",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/JARVIS MID LAYER JACKA - red.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Red",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/JARVIS MID LAYER JACKA - red.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Red",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/JARVIS MID LAYER JACKA - green.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Green",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/JARVIS MID LAYER JACKA - green.jpeg",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Green",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/JARVIS MID LAYER JACKA - green.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Green",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/JARVIS MID LAYER JACKA - black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/JARVIS MID LAYER JACKA - black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "8",
                    imageUrl: "/mocks/JARVIS MID LAYER JACKA - black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "9",
                    imageUrl: "/mocks/JARVIS MID LAYER JACKA - black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
            ],
        };
    }

    return {
        exchangeAlternatives: [
            {
                id: "1",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "2",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                id: "3",
                inventoryMerchant: 0,
                inventoryTurnr: 1,
                inventoryTotal: 1,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
        ],
    };
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "BRIDGE POLO",
                imageSrc: "/mocks/BRIDGE PIKETROJA - white.jpeg",
                imageAlt: "/mocks/BRIDGE PIKETROJA - white.jpeg",
                quantity: 1,
                purchasePrice: 700,
                properties: [
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "White",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
            {
                productVariantId: 20,
                sessionItemId: 2,
                productName: "STUART STRIPED PANT",
                imageSrc: "/mocks/STUART STRIPED BYXOR- black.jpeg",
                imageAlt: "/mocks/STUART STRIPED BYXOR- black.jpeg",
                quantity: 1,
                purchasePrice: 1800,
                properties: [
                    {
                        type: "Color",
                        value: "Black",
                    },
                    {
                        type: "Size",
                        value: "XS",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigBottom(),
            },
            {
                productVariantId: 30,
                sessionItemId: 3,
                productName: "JARVIS MID LAYER JACKET",
                imageSrc: "/mocks/JARVIS MID LAYER JACKA - red.jpeg",
                imageAlt: "/mocks/JARVIS MID LAYER JACKA - red.jpeg",
                quantity: 1,
                purchasePrice: 1300,
                properties: [
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Red",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
        ],
    };
}
